import { ReactNode, useEffect, useState } from 'react';

// third-party
import SimpleBar from 'simplebar-react';

interface SimpleBarScrollProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  browserStyle?: React.CSSProperties;
}

// ==============================|| SIMPLE BAR SCROLL ||============================== //

export default function SimpleBarScroll({ children, className, style, ...other }: SimpleBarScrollProps) {
  const [direction, setDirection] = useState<'ltr' | 'rtl'>('ltr');

  useEffect(() => {
    const rootElement = document.querySelector('[data-pc-direction]');
    const attr = rootElement?.getAttribute('data-pc-direction');
    setDirection(attr === 'ltr' ? 'ltr' : 'rtl');
  }, []);

  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  if (isMobile) {
    return (
      <div style={{ overflowX: 'auto', ...style }} className={className}>
        {children}
      </div>
    );
  }

  return (
    <div style={{ flexGrow: 1, height: '100%', overflow: 'hidden' }}>
      <SimpleBar
        clickOnTrack={false}
        style={{ maxHeight: '100%', ...style }}
        className={className}
        data-simplebar-direction={direction}
        {...other}
      >
        {children}
      </SimpleBar>
    </div>
  );
}
